import { Skeleton } from '@/shared/components/ui/skeleton';

/** Route-level pending shape for the invitations list and its organization filter. */
export function AdminInvitationsSkeleton() {
  return (
    <div className="flex flex-1 flex-col gap-3 p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="space-y-1">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-3 w-80" />
        </div>
        <Skeleton className="h-7 w-24 rounded-md" />
      </div>
      <Skeleton className="h-7 w-48 rounded-md" />
      <div className="space-y-2 rounded-md border p-2">
        {Array.from({ length: 6 }, (_, index) => index).map((index) => (
          <div key={index} className="flex items-center gap-3">
            <Skeleton className="h-4 flex-1" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-20" />
          </div>
        ))}
      </div>
    </div>
  );
}
